import {
  ARTICLE_CATEGORY_BY_SLUG,
  ARTICLE_CATEGORY_SLUGS,
} from "../articles/catalog";

export const ARTICLES_PER_PAGE = 12;
export const ARTICLE_SORTS = ["newest", "oldest", "title"];

const normalize = (value) => String(value || "").trim().toLocaleLowerCase();

export const isEditorialView = ({ q, category, sort }) =>
  !q && !category && sort === "newest";

export const parseArticleSearchParams = (searchParams) => {
  const q = (searchParams.get("q") || "").trim();
  const categorySlug = searchParams.get("category") || "";
  const sortParam = searchParams.get("sort") || "newest";
  const parsedPage = Number.parseInt(searchParams.get("page") || "1", 10);

  return {
    q,
    category: ARTICLE_CATEGORY_BY_SLUG[categorySlug] || "",
    sort: ARTICLE_SORTS.includes(sortParam) ? sortParam : "newest",
    page: Number.isInteger(parsedPage) && parsedPage > 0 ? parsedPage : 1,
  };
};

export const createArticleSearchParams = ({ q, category, sort, page }) => {
  const params = new URLSearchParams();

  if (q) params.set("q", q);
  if (category && ARTICLE_CATEGORY_SLUGS[category]) {
    params.set("category", ARTICLE_CATEGORY_SLUGS[category]);
  }
  if (sort && sort !== "newest") params.set("sort", sort);
  if (page > 1) params.set("page", String(page));

  return params;
};

export const filterAndSortArticles = (articles, { q, category, sort }) => {
  const query = normalize(q);
  const filtered = articles.filter((article) => {
    const matchesCategory = !category || article.category === category;
    const searchText = normalize(
      [article.title, article.summary, article.category, ...(article.topics || [])].join(" ")
    );
    return matchesCategory && (!query || searchText.includes(query));
  });

  return [...filtered].sort((a, b) => {
    if (sort === "oldest") return new Date(a.date) - new Date(b.date);
    if (sort === "title") return a.title.localeCompare(b.title);
    return new Date(b.date) - new Date(a.date);
  });
};

export const getArticleArchive = (articles, state) => {
  const featured =
    [...articles].sort((a, b) => new Date(b.date) - new Date(a.date))[0] || null;
  const editorial = isEditorialView(state);
  const searchableArticles = editorial && featured
    ? articles.filter((article) => article.slug !== featured.slug)
    : articles;

  return {
    featured: editorial ? featured : null,
    articles: filterAndSortArticles(searchableArticles, state),
    editorial,
  };
};

export const paginateArticles = (articles, requestedPage, perPage = ARTICLES_PER_PAGE) => {
  const pageCount = Math.max(1, Math.ceil(articles.length / perPage));
  const page = Math.min(Math.max(1, requestedPage), pageCount);
  const start = (page - 1) * perPage;

  return {
    page,
    pageCount,
    items: articles.slice(start, start + perPage),
  };
};
